import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollService } from './services/scroll.service';

@NgModule({
    imports: [CommonModule],
    providers: [ScrollService],
})
export class ScrollModule {}
